import ControlButton2 from "./controls/ControlButton";
import { materialRenderers } from "@jsonforms/material-renderers";
import ControlRadio from "./controls/ControlRadio";
import ControlInput from "./controls/ControlInput";
import ControlEmptyBox from "./controls/ControlEmptyBox";
import MaterailLayoutHorizontal from "./layouts/HorizontalControl";
import { materialHorizontalLayoutTester } from "./layouts/HorizontalControl";
import ControlDate from "./controls/ControlDate";
import ControlLabel from "./controls/ControlLabel";
import ControlNotify from "./controls/ControlNotify";
import ControlPassword from "./controls/ControlPassword";

import TabLayoutControl, { TabLayoutTester } from "./layouts/TabControl";
import  rankTester, { rankArrayTester } from "./rankTester/rankTester"
import ControlIconButton from "./controls/ControlIconButton";
import  { MultiSelectControl, SelectControl } from "./controls/ControlAutoComplete";
import { WrapperLayoutControl, WrapperLayoutTester } from "./layouts/WrapperControl";
import ControlGraph from "./controls/ControlGraph";
import ControlProgressBar from "./controls/ControlProgressBar";
import ControlSpeedoMeter from "./controls/ControlSpeedoMeter";
import { SliderLayoutControl, SliderLayoutTester } from "./layouts/SliderControl";
import ControlTimer from "./controls/ControlTimer";
import TextArea from "./components/TextArea";
import Image from "./components/Image";
import RollAndDice from "./components/RollAndDice";
import RunningBoyProgressBar from "./components/RunningBoyProgressBar";
import Slider from "./components/Slider";
import RankCard from "./components/RankCard";
import Checkbox from "./components/Checkbox";
import Table from "./components/Table/Table";
import ControlInputSlider from "./controls/ControlInputSlider";
import FileInput from "./components/FileInput";
import PopUp from "./components/PopUp";
import Stepper from "./components/Stepper";
import DataGrid from "./components/DataGrid";
import ControlOTPInput from "./controls/ControlOTPInput";
import ControlDateTime from "./controls/ControlDateTime";
import Iframe from "./components/Iframe";
import TreeMap from "./components/TreeMap/TreeMapWrapper";
import Thought from "./components/ThoughtOfTheDay";
import LeaderBoard from "./components/LeaderBoard";
import Array from "./components/Array/Array";
import Breadcrumb from "./components/Breadcrumb";
import Camera from "./components/CameraWidget/Index";
import ButtonGroup from "./components/ButtonGroup";
import Popover from "./components/Popover";
import MetricCard from './components/MetricCard';
import PdfViewer from "./components/PdfViewer/PdfViewer";
import HierarchyChart from "./components/HierarchyChart";
export const renderers:any = [
  ...materialRenderers,
  {
    tester: materialHorizontalLayoutTester,
    renderer: MaterailLayoutHorizontal,
  },
  { tester: TabLayoutTester, renderer: TabLayoutControl },
  { tester: WrapperLayoutTester, renderer: WrapperLayoutControl},
  { tester: SliderLayoutTester, renderer: SliderLayoutControl},
  { tester: rankTester("Timer"), renderer: ControlTimer },
  { tester: rankTester("Graph"), renderer: ControlGraph },
  { tester: rankTester("Table"), renderer: Table }, 
  { tester: rankTester("Box"), renderer: ControlLabel },
  { tester: rankTester("InputField"), renderer: ControlInput },
  { tester: rankTester("PasswordInputField"), renderer: ControlPassword },
  { tester: rankTester("DownloadFile"), renderer: FileInput },
  { tester: rankTester("UploadFile"), renderer: FileInput },
  { tester: rankTester("DateInputField"), renderer: ControlDate },
  { tester: rankTester("DateTimeInputField"), renderer: ControlDateTime},
  { tester: rankTester("SelectInputField"), renderer: SelectControl },
  { tester: rankTester("Button"), renderer: ControlButton2 },
  { tester : rankTester("Iframe") , renderer : Iframe},
  { tester: rankTester("IconButton"), renderer: ControlIconButton },
  { tester: rankTester("EmptyBox"), renderer: ControlEmptyBox },
  { tester: rankTester("RadioInputField"), renderer: ControlRadio },
  { tester: rankTester("Notify"), renderer: ControlNotify },
  { tester: rankTester("MultipleSelect"), renderer: MultiSelectControl },
  { tester: rankTester("ProgressBar"), renderer: ControlProgressBar },
  { tester: rankTester("SpeedoMeter"), renderer: ControlSpeedoMeter },
  { tester: rankTester("TextArea"), renderer: TextArea },
  { tester: rankTester("Image"), renderer: Image },
  { tester: rankTester("Slider"), renderer: Slider },
  { tester: rankTester("RunnerBoyProgressBar"), renderer: RunningBoyProgressBar },
  { tester: rankTester("RollAndDice"), renderer:RollAndDice  },
  { tester: rankTester("RankCard"), renderer:RankCard  },
  { tester: rankTester("CheckBox"), renderer:Checkbox  },
  { tester: rankTester("InputSlider"), renderer:ControlInputSlider  },
  { tester: rankTester("FileInputField"), renderer:FileInput  },
  { tester: rankTester("PopUp"), renderer: PopUp},
  { tester: rankTester("Stepper"), renderer:Stepper },
  { tester: rankTester("DataGrid"), renderer:DataGrid },
  { tester: rankTester("OTPInput"), renderer:ControlOTPInput },
  { tester: rankTester("DateTimeInputField"), renderer: ControlDateTime},
  { tester: rankTester("TreeMap"), renderer:TreeMap },
  { tester: rankTester("Thought"), renderer:Thought },
  { tester: rankTester("LeaderBoard"), renderer:LeaderBoard  },
  { tester: rankArrayTester, renderer:Array  },
  { tester: rankTester("Breadcrumb"), renderer:Breadcrumb  },
  { tester: rankTester("Camera"), renderer:Camera},
  { tester: rankTester("ButtonGroup"), renderer: ButtonGroup},
  { tester: rankTester("Popover"), renderer: Popover },
  { tester: rankTester("MetricCard"), renderer: MetricCard },
  { tester: rankTester("PdfViewer"), renderer:PdfViewer},
  { tester: rankTester("HierarchyChart"), renderer: HierarchyChart }
];
export default renderers;
